export * from './IconFlame';
export { default as IconFlame } from './IconFlame';
